exports.install = function (Vue, options) {
	//获取萤石云单视频
	Vue.prototype.getysyone = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		return this.axiosget("/api/ysy/getOne",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('ysyone',response.data.data);
			}
			return response;
		})
	};
	//获取萤石云视频列表
	Vue.prototype.getysylist = function(value)
	{
		value.limitPage=this.$store.state.production.page;
		value.limitCount=this.$store.state.production.pagesize;
		value.qaedas_id=this.getCookie(this.config.jdid);
		return this.axiosget("/api/ysy/getAll",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('ysylist',response.data.data);
			}
			return response;
		})
	};
	//获取抓拍图片列表
	Vue.prototype.getysyphoto = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiosget("/api/ysy/getCaptureList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('ysyphoto',response.data.data.list);
			}
		})
	};
	//刷新设备
	Vue.prototype.refreshD = function(value={})
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiospost("/api/ysy/refreshDevices",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getvcr();
			}
			return response;
		});
	};
	//启动控制动作
	Vue.prototype.ptzStart = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiospost("/api/ysy/ptzStart",value);
	};
	//停止控制动作
	Vue.prototype.ptzStop = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiospost("/api/ysy/ptzStop",value);
	};
	//图像翻转
	Vue.prototype.ptzMirror = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiospost("/api/ysy/ptzMirror",value);
	};
	//抓拍图像
	Vue.prototype.capture = function(value)
	{
		value.qaedas_id=this.getCookie(this.config.jdid);
		this.axiospost("/api/ysy/deviceCapture",value);
	};
	//删除抓拍图像
	Vue.prototype.delcapture = function(value)
	{
		this.axiospost("/api/ysy/deleteCaptureList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getysyphoto(value);
			}
		});
	};
}